import React, { useState } from "react";
import "./ChangePasswordModal.css";
import { FaLock, FaKey } from "react-icons/fa";

const ChangePasswordModal = ({ isOpen, onClose, onConfirm }) => {
  const [senha_atual, setSenhaAtual] = useState("");
  const [nova_senha, setNovaSenha] = useState("");
  const [confirmar_senha, setConfirmarSenha] = useState("");

  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm({ senha_atual, nova_senha, confirmar_senha });
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Alterar Senha</h2>
        <div className="password-input-group">
          <FaKey className="input-icon" />
          <input
            type="password"
            placeholder="Senha Atual"
            value={senha_atual}
            onChange={(e) => setSenhaAtual(e.target.value)}
            required
            className="form-modern"
          />
        </div>
        <div className="password-input-group">
          <FaLock className="input-icon" />
          <input
            type="password"
            placeholder="Nova Senha"
            value={nova_senha}
            onChange={(e) => setNovaSenha(e.target.value)}
            required
            className="form-modern"
          />
        </div>
        <div className="password-input-group">
          <FaLock className="input-icon" />
          <input
            type="password"
            placeholder="Confirmar Nova Senha"
            value={confirmar_senha}
            onChange={(e) => setConfirmarSenha(e.target.value)}
            required
            className="form-modern"
          />
        </div>
        <div className="modal-actions">
          <button onClick={onClose} className="button-secondary">
            Cancelar
          </button>
          <button onClick={handleConfirm} className="btn-modern">
            Salvar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordModal;
